import { DateTime } from './date_utils/all'
import { PeriodData } from './periods/period_data'
import { PeriodBuilder } from './periods/period_strategy';
import { Formatter } from "./utils/formatter"

export default class App {
  constructor() {
    this.debugging = false;
    this.data = {}
    this.charts = []
    this.graphs = []
    this.tabs = []
    this.accordions = []
    this.scenarioForm = {}
    this.resetables = {}
    this.isos = {}
    this.periods = window.periods
    this.periodData = new PeriodData(window.periods)
    this.sortables = []
    this.fundData = {}
  }

  debug() {
    this.debugging = true;

    document.addEventListener("turbo:before-cache", function() {
      console.log('turbo:before-cache');
    })

    document.addEventListener("turbo:before-render", function() {
      console.log('turbo:before-render');
    })
  }

  listen(name) {
    document.addEventListener(name, event => console.log(event))
  }

  dispatch(elem, eventName, options) {
    const opts  = Object.assign({bubbles: true}, options)
    const event = new CustomEvent(eventName, opts)

    if (this.debugging) { console.log(eventName) }

    elem.dispatchEvent(event)
  }

  /**
   * Used for charts specifically
   */
  dataLookup(bindId, index) {
    return this.graphs[bindId]?.currentData?.data?.json[index]
  }

  setData(dataId, data) {
    this.data[dataId] = data
  }

  getData(dataId) {
    return this.data[dataId]
  }

  get luxon() {
    return DateTime
  }

  get periodsArray() {
    let arr = []

    for(const [name, period] of Object.entries(this.periods)) {
      period.name = name
      arr.push(period)
    }

    return arr
  }

  get neoPeriods() {
    return new PeriodBuilder(window.neoPeriods)
  }

  get formatter() {
    return Formatter
  }

  randomString(length) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return result;
  }
}

export { App }
